_ = require 'underscore'
$ = require 'jquery'
AddEmailPopoverView = require 'views/member/add-email-popover-view'
Auth = require 'db/auth'
ChangeAvatarPopoverView = require 'views/member/change-avatar-popover-view'
ChangeEmailPopoverView = require 'views/member/change-email-popover-view'
ChangeEmailFreqPopoverView = require 'views/member/change-email-freq-popover-view'
ChangeLocaleView = require 'views/member/change-locale-view'
ChangeSetPasswordPopoverView = require 'views/member/change-set-password-popover-view'
ChangeUserInfoPopoverView = require 'views/member/change-user-info-popover-view'
DesktopNotification = require 'lib/desktop-notification'
MemberApplicationsView = require 'views/member/member-applications-view'
MemberDeleteConfirmView = require 'views/member/member-delete-confirm-view'
MemberLoginsView = require 'views/member/member-logins-view'
MemberSessionsView = require 'views/member/member-sessions-view'
MemberView = require 'views/member/member-view'
MobilePasswordPopoverView = require 'views/member/mobile-password-popover-view'
PopOver = require 'views/lib/pop-over'
SimplifiedStateManager = require 'lib/simplified-state-manager'
Util = require 'lib/util'
ldclient = require 'lib/ldclient'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'

module.exports = class MemberAccountView extends MemberView
  initialize: ->
    super
    @listenTo @model, 'change:loginTypes change:prefs change:tokens change:credentials change:marketingOptIn',
      @frameDebounce @renderMainContent

    @listenTo SimplifiedStateManager, 'full-view:unlocked',
      @frameDebounce @renderMainContent

  events:
    'click .js-simple-view-opt-out': 'optOutSimplifiedView'
    'click .js-change-avatar': 'changeAvatar'
    'click .js-change-name-and-bio': 'changeUserInfo'
    'click .js-change-password': 'changePassword'
    'click .js-change-email': 'changeEmail'
    'click .js-change-locale': 'changeLocale'

    'click .js-configure-2fa': 'configure2FA'

    'click .js-change-email-freq': 'changeEmailFreq'
    'click .js-allow-desktop-notifications': 'allowDesktopNote'

    'click .js-marketing-opt-in': 'marketingOptIn'

    'click .js-marketing-opt-out': 'marketingOptOut'

    'click .js-toggle-cb-mode': 'toggleCB'

    'click .js-confirm-delete-member': 'deleteConfirm'

    'click .js-add-email': 'addEmail'

    'click .js-mobile-temp-password': 'mobileTempPassword'

    'click .js-personal-data-export': 'personalDataExport'

  renderMainContent: ->
    data = @model.toJSON(prefs: true, hasPassword: true)
    data["avatarSource_#{ data.avatarSource }"] = true

    data.canAllowDesktopNotifications = DesktopNotification.notEnabled()
    data.cbEnabled = @model.get('prefs').colorBlind
    data.marketingOptIn = @model.get('marketingOptIn')?.optedIn
    data.showMarketingOptIn = ldclient.variation('scale.marketing_opt_in_setting', false)

    # We don't need to show the current junky mobile login password feature
    # to everyone, just people who might need it: SSO users.
    data.showMobileLoginPassword = _.any @model.get('credentials'), (c)->
      c.type == 'saml'

    data.canUsePassword = !@model.isSSOOnly()
    data.hasTriggeredFullView = SimplifiedStateManager.isUnlocked('full-view')

    @$('.js-content').html(
      templates.fill(
        'member_account',
        data,
        { editable: Auth.isMe(@model) }
      )
    )

    @$('.js-member-applications').html(@subview(MemberApplicationsView, @model).render().el)
    @$('.js-member-sessions').html(@subview(MemberSessionsView, @model).render().el)

    $credsSection = @$('.js-credentials-section')
    $credsList = @$('.js-credentials-list')

    $credsList.empty()
    if @model.get('logins').length > 0
      loginsSubview = @collectionSubview(MemberLoginsView, @model.loginList, { @model })
      @appendSubview(loginsSubview, $credsList)

    @setActiveView('.js-member-account')
    @

  optOutSimplifiedView: ->
    if !Auth.me().isDismissed('simplified-view-full-view')
      Auth.me().dismiss('simplified-view-full-view')
      @renderMainContent()

  changeUserInfo: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Open Change User Info Menu")
    PopOver.toggle
      elem: @$('.js-change-name-and-bio')
      view: new ChangeUserInfoPopoverView({ @model, @modelCache })

  addEmail: (e) ->
    Util.stop(e)
    track('Member View', 'Settings Page', 'Open Add Email Menu')
    PopOver.toggle
      elem: $(e.target)
      view: new AddEmailPopoverView({ @model, @modelCache })

  mobileTempPassword: (e) ->
    Util.stop(e)
    track('Member View', 'Settings Page', 'Generate Temporary Mobile Password')
    @model.getMobileTempPassword (tempPassword) ->
      PopOver.toggle
        elem: $(e.target)
        view: new MobilePasswordPopoverView({ tempPassword })

  personalDataExport: (e) ->
    trackUe('account settings', 'downloads', 'personal data', '', '',
        'by clicking download personal data button')

  changeAvatar: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Open Change Avatar Menu")
    PopOver.toggle
      elem: @$('.js-change-avatar')
      view: new ChangeAvatarPopoverView({ @model, @modelCache })

  changePassword: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Open Change Password Menu")
    PopOver.toggle
      elem: @$('.js-change-password')
      view: new ChangeSetPasswordPopoverView({ @model, @modelCache })

  changeEmail: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Open Change Email Menu")
    PopOver.toggle
      elem: @$('.js-change-email')
      view: new ChangeEmailPopoverView({ @model, @modelCache })

  configure2FA: (e) ->
    track("Member View", "Settings Page", "Configure 2FA")

  changeLocale: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Change Language")
    onChange = (oldLocale, newLocale) -> if oldLocale != newLocale then document.location.reload()
    PopOver.toggle
      elem: @$('.js-change-locale')
      view: new ChangeLocaleView({ @model, @modelCache, onChange })

  changeEmailFreq: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Open Change Frequency Menu")
    PopOver.toggle
      elem: @$('.js-change-email-freq')
      view: new ChangeEmailFreqPopoverView({ @model, @modelCache })

  allowDesktopNote: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Allow Desktop Notifications")

    DesktopNotification.requestPermission()
    .finally(=> @render())

    return

  setMarketingOpt: (e, optedIn) ->
    Util.stop(e)
    if optedIn
      trackUe('account settings', 'opt in to', 'marketing', 'member', '',
        'by clicking the opt-in link')
    else
      trackUe('account settings', 'opt out of', 'marketing', 'member', '',
        'by clicking the opt-out link')
    @model.setMarketingOptIn(optedIn)
    return

  marketingOptIn: (e) ->
    @setMarketingOpt(e, true)

  marketingOptOut: (e) ->
    @setMarketingOpt(e, false)

  toggleCB: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Toggle Color Blind Mode")
    @model.toggleColorBlindMode()
    return

  deleteConfirm: (e) ->
    Util.stop(e)
    track("Member View", "Settings Page", "Open Delete Account Confirmation Menu")
    PopOver.toggle
      elem: @$('.js-confirm-delete-member')
      view: new MemberDeleteConfirmView({ @model, @modelCache })

    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-account-view.coffee